<script>
export default {
  name: 'UhProgressBar',

  props: {
    noStripes: {
      type: Boolean,
      default: false,
    },

    variant: {
      type: String,
      default: 'blue',
      validator: (value) => ['blue', 'green', 'orange', 'red'].includes(value),
    },

    value: {
      type: [Number, String],
      default: 0,
      required: true,
    },
  },
};
</script>

<template>
  <div class="meter" :class="[variant, { nostripes: noStripes }]">
    <span :style="{ width: Number(value) + '%' }"></span>
  </div>
</template>
<style lang="scss" scoped>
.meter {
  box-sizing: content-box;
  position: relative;
  background: rgb(234, 234, 234);
  height: 10px;
  margin: 0.2em 0;
  padding: 1px;
  box-shadow: inset 0 -1px 1px rgba(255, 255, 255, 0.3);
}
.meter > span {
  display: block;
  height: 100%;
  background-color: rgb(0, 162, 225);
  background-image: linear-gradient(
    center bottom,
    rgb(0, 162, 225) 37%,
    rgb(0, 123, 172) 69%
  );
  box-shadow: inset 0 2px 9px rgba(255, 255, 255, 0.3),
    inset 0 -2px 6px rgba(0, 0, 0, 0.4);
  position: relative;
  overflow: hidden;
}
.meter > span:after,
.animate > span > span {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-image: linear-gradient(
    -45deg,
    rgba(255, 255, 255, 0.2) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.2) 50%,
    rgba(255, 255, 255, 0.2) 75%,
    transparent 75%,
    transparent
  );
  z-index: 1;
  background-size: 50px 50px;
  animation: move 2s linear infinite;
  overflow: hidden;
}

.animate > span:after {
  display: none;
}

@keyframes move {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 50px 50px;
  }
}

.green > span {
  background-image: linear-gradient(#2bc253, #2bc253);
}

.orange > span {
  background-image: linear-gradient(#f1a165, #f36d0a);
}

.red > span {
  background-image: linear-gradient(#f0a3a3, #f42323);
}

.nostripes > span > span,
.nostripes > span::after {
  background-image: none;
}
</style>
